import React from 'react';
import '@components/ImageCarousel/image-carousel.scss';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";

interface IProps {
  imgList: string[],
  imgCur: number
}

const ImageCarousel = ({imgList, imgCur}: IProps) => {
  let cur = imgCur >= imgList.length ? imgCur - (4 - imgList.length) : imgCur;
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'ic-dots',
    initialSlide: cur
  };

  return (
    <Slider {...settings} className="img-carousel">
      {
        imgList.map((img: string, index:  number) =>
          <div key={index}>
            <img src={img} alt=""/>
          </div>
        )
      }
    </Slider>
  );
}

export default ImageCarousel;
